import { Tooltip } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";

const ClippedElement = ({ children, tooltipTitle, maxWidth }) => {
  const clippedEl = useRef();
  const [clipped, setClipped] = useState(false);

  useEffect(() => {
    const listener = window.addEventListener("resize", () => {
      checkIfClippedOrNot();
    });

    checkIfClippedOrNot();

    return () => {
      window.removeEventListener("resize", listener);
    };
  }, []);

  const checkIfClippedOrNot = () => {
    if (clippedEl.current?.clientWidth < clippedEl.current?.scrollWidth) {
      setClipped(true);
    } else {
      setClipped(false);
    }
  };

  return clipped ? (
    <Tooltip title={tooltipTitle}>
      <div
        ref={clippedEl}
        className="clipped"
        style={
          maxWidth
            ? { maxWidth, unicodeBidi: "initial" }
            : { unicodeBidi: "initial" }
        }
      >
        {children}
      </div>
    </Tooltip>
  ) : (
    <div
      ref={clippedEl}
      className="clipped"
      style={maxWidth ? { maxWidth } : {}}
    >
      {children}
    </div>
  );
};

export default ClippedElement;
